import { Button, Flex } from "@chakra-ui/react";
import { InboxIcon, CalendarIcon } from "../../icons";
import { MOBILE_VIEW_TYPE, mobileViewType } from "../../types/main";

import { usePreference } from "../../hooks/preference/usePreference";

const MobileToolbar = () => {
  const { preference: userPreference } = usePreference();

  const mobileView = userPreference?.mobileView ?? MOBILE_VIEW_TYPE.INBOX;
  const { updatePreference } = usePreference();

  const handleMobileView = (view: mobileViewType) => {
    updatePreference({ mobileView: view });
  };

  return (
    <Flex
      position={"fixed"}
      bottom={"30px"}
      left={"50%"}
      transform={"translate(-50%)"}
      zIndex={1000}
      backdropBlur={"blue"}
      background={"#4a4c4d"}
      borderRadius={"7px"}
      padding={"6px"}
      gap={1}
      boxShadow={" 0px 4px 4px 0px rgba(0, 0, 0, 0.25);"}
    >
      <Button
        variant="ghost"
        padding={"5px 10px"}
        h={"fit-content"}
        borderRadius={"5px"}
        background={mobileView === MOBILE_VIEW_TYPE.INBOX ? "rgba(255, 255, 255, 0.24)" : "#4A4C4D"}
        boxSizing="border-box"
        _hover={{ background: "rgba(255, 255, 255, 0.24)" }}
        onClick={() => handleMobileView(MOBILE_VIEW_TYPE.INBOX)}
      >
        <InboxIcon
          w={6}
          h={6}
          color="white"
        />
      </Button>
      <Button
        variant={"ghost"}
        h={"fit-content"}
        padding={"5px 10px"}
        borderRadius={"5px"}
        background={
          mobileView === MOBILE_VIEW_TYPE.CALENDAR ? "rgba(255, 255, 255, 0.24)" : "#4A4C4D"
        }
        boxSizing="border-box"
        _hover={{ background: "rgba(255, 255, 255, 0.24)" }}
        onClick={() => handleMobileView(MOBILE_VIEW_TYPE.CALENDAR)}
      >
        <CalendarIcon
          w={6}
          h={6}
          color={"white"}
        />
      </Button>
    </Flex>
  );
};

export default MobileToolbar;
